import { useEffect, useState } from "react";

// Simple app-wide light/dark preference, persisted + reactive via a window event.
const KEY = "jeeo_theme";
const EVT = "jeeomodechange";

export const getMode = () => localStorage.getItem(KEY) || "dark";

export const setMode = (m) => {
  localStorage.setItem(KEY, m);
  window.dispatchEvent(new Event(EVT));
};

export const toggleMode = () => setMode(getMode() === "dark" ? "light" : "dark");

export const useMode = () => {
  const [mode, setModeState] = useState(getMode());
  useEffect(() => {
    const h = () => setModeState(getMode());
    window.addEventListener(EVT, h);
    return () => window.removeEventListener(EVT, h);
  }, []);
  return mode;
};
